module.exports = __webpack_public_path__ + "media/images/emoticons/tv-197b96139386ded38ed34640f3af4843.gif";